import React from 'react';
import Quiz from '../components/Quiz';
import { dataStructuresQuizQuestions } from '../data/quizzes/dataStructuresQuiz';
import { useNavigate } from 'react-router-dom';

export default function DataStructuresQuiz() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0f0f11] text-white/90">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate('/topic/data-structures')}
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Theory
          </button>
        </div>
        <h1 className="text-3xl font-bold text-white mb-2">Data Structures Quiz</h1>
        <p className="text-white/70 mb-8">
          Test your understanding of fundamental data structures and their applications with these practice questions.
        </p>
        <Quiz questions={dataStructuresQuizQuestions} />
      </div>
    </div>
  );
}
